import C1_EloItem from "../model/C1_EloItem";
import type { C1_EloGroup } from "../model/C1_EloGroup";
import { C1_EloItem_Type } from "../types/C1_EloTypes";

/** Steckplatzauswahl beibehalten, aber die nächste Steckdosengruppe bearbeiten. */
export function socketGroupForSelection(item: C1_EloItem): C1_EloGroup | undefined {
  if (item.definition?.toDefinition().type !== C1_EloItem_Type.Plug) return undefined;
  const seen = new Set<C1_EloItem>();
  for (let parent = item.parent; parent instanceof C1_EloItem && !seen.has(parent); parent = parent.parent) {
    if (parent.definition?.toDefinition().type === C1_EloItem_Type.PlugGroup) return parent as C1_EloGroup;
    seen.add(parent);
  }
  return undefined;
}
